import React from "react";
import "./formsTitle.scss";
export const FormsTitle = () => {
	return (
		<div className="formsTitle">
			<h1 className="headlineTittle">Fundamentals of Scheduling & Labor</h1>
		</div>
	);
};
